import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-military-calisthenics-al',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-military-calisthenics-f', 'age-military-calisthenics-f-pr'],
		route: {
			path: '/military-calisthenics-f-al',
			name: 'military-calisthenics-f-al-funnel',
		},
	},
	funnel: {
		id: 'ob-female-military-calisthenics-al',
		route: {
			path: '/military-calisthenics-f-al/ob/:page(.*)?',
			name: 'activity-female-military-calisthenics-al',
		},
		slug: 'activity-female-military-calisthenics-al',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-military-calisthenics-f-al',
	},
	upsell: {
		routeNames: ['upsell-military-calisthenics-f'],
	},
}

export default appAreaConfig
